// extracted by mini-css-extract-plugin
export var upgradeCartDisclaimer = "UpgradeDisclaimer_upgradeCartDisclaimer__hQJHR";
export var upgradeDisclaimerContainer = "UpgradeDisclaimer_upgradeDisclaimerContainer__O3kBW";